import { useContext, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Post from "../../api/Post";
import { SURVEY_ANSWER_SAVE } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import PreguntaLineal from "../survey/PreguntaLineal";
import PreguntaOpcionMultiple from "../survey/PreguntaOpcionMultiple";
import PreguntaSeleccionIndividual from "../survey/PreguntaSeleccionIndividual";
import PreguntaTexto from "../survey/PreguntaTexto";

function ComponentModalEncuentaDoctor({t, cita, show, setShowEncuesta,setShowSuccess, handleClose, question, setShowModalServer, setErrorServer}){
    const [saveSurvey, setSaveSurvey] = useState(false)
    const [answer, setAnswer] = useState([])
    const [checkLinealStado, setCheckLinealStado] = useState([])
    const {auth} = useContext(authContext)
    const history = useHistory()


    const fillAnswer = (obj) =>{
        let findIndex = answer.findIndex(ele=>ele.id===obj.id)
        if(findIndex >= 0){
            let arr = [...answer]
            arr[findIndex] = obj
            setAnswer(arr)
        }else{
            let arr = [...answer]
            arr.push(obj)
            setAnswer(arr)
        }
    }

    const onHandleLinealAnswer = (respuesta, item) =>{        
        let obj = JSON.parse(JSON.stringify(item));
        obj.options = [respuesta]

        fillAnswer(obj)

        let arr = [...checkLinealStado]        
        let findIndex = answer.findIndex(ele=>ele.id===obj.id)
        if(findIndex>=0){
            let findi = arr.findIndex(el=>el.id===answer[findIndex].id)
            if(findi>=0){
                arr[findi] = obj
                setCheckLinealStado(arr)
            }
        }else{
            arr.push(obj)
            setCheckLinealStado(arr)
            
        }
    }

    //respuesta multiple    
    const onHandleMultipleAnswer = (respuesta, checked, item) =>{
        let obj = JSON.parse(JSON.stringify(item))        
        let findIndexObjCreate = answer.findIndex(el=>el.id===item.id)
        if(checked){
            if(findIndexObjCreate>=0){
                obj = answer[findIndexObjCreate]
                obj.options.push(respuesta)
            }else{
                obj.options = [respuesta]
            }
        }else{
            if(findIndexObjCreate>=0){
                let arr = answer[findIndexObjCreate].options.filter(el=>el!==respuesta)
                obj.options = arr
            }   
        }
        fillAnswer(obj)
    }
    //respuesta seleccion individual
    const onHandleIndividualAnswer = (respuesta, item) =>{
        let obj = JSON.parse(JSON.stringify(item))
        let findIndexObjCreate = answer.findIndex(el=>el.id===item.id)
        if(findIndexObjCreate>=0){
            obj = answer[findIndexObjCreate]
            obj.options = [respuesta]
        }else{
            obj.options = [respuesta]
        }
        fillAnswer(obj)
    }
    //respuesta de texto
    const onHandleTextoAnswer = (texto, item) =>{
        let obj = item;
        obj.options = [texto]

        //console.log(obj)
        fillAnswer(obj)        
    }

    //Guardar la encuesta de satisfaccion
    const sendEncuesta = e => {
        setSaveSurvey(true)
        let d = {
            id: cita.id,
            surveys: answer
        }        
        //Guardar la encuesta
        Post({url: SURVEY_ANSWER_SAVE, data: d, access_token: auth.data.access_token, header: true})
        .then(response=>{
            setSaveSurvey(false)
            setShowEncuesta(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
                history.replace("/admin")
            }, 2000);
        })
        .catch(error=>{
            //console.log("Error al guardar la encuesta de satisfacción",error)
            setSaveSurvey(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        })
        //setTimeAppointment(cita, 'Doctor', false, cita.dataVideoCallList, auth)
    }


    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
            {saveSurvey && <SimpleLoad />}
            <Modal.Header closeButton className="border-0">
            </Modal.Header>
            <Modal.Body className="px-5">                
                <Row>
                    <Col xs="12" md="12">
                        <h3 className="text-black"> {t('encuesta_satisfaccion')} </h3>                        
                    </Col>

                    {
                        question.map((item,i)=>(
                            <Col xs="12" md="12" key={i} className="mb-3">
                                {
                                    item.questionType.nombreTipoPregunta==='Lineal' ?
                                    <PreguntaLineal item={item} onHandleLinealAnswer={onHandleLinealAnswer} checkLinealStado={checkLinealStado}/> :
                                    item.questionType.nombreTipoPregunta==='OpcionMultiple' ?
                                    <PreguntaOpcionMultiple item={item} onHandleMultipleAnswer={onHandleMultipleAnswer}/> :
                                    item.questionType.nombreTipoPregunta==="SeleccionIndividual" ?
                                    <PreguntaSeleccionIndividual item={item} onHandleIndividualAnswer={onHandleIndividualAnswer}/> :
                                    <PreguntaTexto item={item} onHandleTextoAnswer={onHandleTextoAnswer}/>
                                }
                            </Col>
                        ))
                    }
                    
                </Row>                
                <hr className="mb-0 dashed"/>
                <Row>
                    <Col xs="12" md="12">
                        <div className="text-center text-md-right bg-light py-3 px-3">                            
                            <Button variant="primary"className="ok-primary" onClick={sendEncuesta}>
                                {t('enviar')}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default withTranslation()(ComponentModalEncuentaDoctor)